import React from 'react';

import StepShell from './steps/StepShell';

/**
 * Stands in for a step's own page until that page ships. The wizard shell
 * still drives navigation, deferral and status around it.
 */
export default function StepPlaceholder({ step, deferring, saving, onDefer, onNext }) {
    return (
        <StepShell step={step} deferring={deferring} saving={saving} onDefer={onDefer} onNext={onNext}>
            <p className="tw-text-sm tw-text-charcoal-75">{$t('This step is not available yet. It will be added in a later release.')}</p>
        </StepShell>
    );
}
